import { Image, SystemStyleObject } from "@chakra-ui/react";
import { assets } from "../../../assets";

type Iprops = {
  sx?: SystemStyleObject;
};

const AuthIllustration = (props: Iprops = {}) => {
  return (
    <Image
      sx={props.sx}
      height={{ base: "7rem", md: "9rem", lg: "20rem" }}
      src={assets.illustrations.rocketIllustration}
    />
  );
};

export default AuthIllustration;
